import { Typography } from '@mui/material';
import { BulletListContainer, BulletListItem, BulletMark } from './BulletList.styled';

interface IBulletListProps {
  items: string[];
}

// Shared bulleted list used in the case description (live view + PDF). See
// BulletList.styled.tsx for why the bullet is a real element instead of a list marker.
export const BulletList = ({ items }: IBulletListProps) => (
  <BulletListContainer>
    {items.map((el) => (
      <BulletListItem key={el} data-pdf-keep-together>
        <BulletMark aria-hidden={'true'}>•</BulletMark>
        <Typography variant={'body1'}>{el}</Typography>
      </BulletListItem>
    ))}
  </BulletListContainer>
);
